import { updatesItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
              最新动向
            </h2>
            <p className="text-foreground-500 text-sm">实时追踪吃瓜圈最新动态</p>
          </div>
          <div className="relative pl-8 before:absolute before:left-4 before:top-0 before:bottom-0 before:w-px before:bg-background-300">
            {updatesItems.map((item, idx) => (
              <div key={idx} className="relative pb-6 last:pb-0">
                <span className="absolute -left-[22px] w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></span>
                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <span className="text-xs text-foreground-500 whitespace-nowrap flex-shrink-0">{item.time}</span>
                  <div className="flex-1">
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {item.content}
                    </p>
                    <span className="inline-block mt-2 px-2 py-0.5 bg-secondary-100 text-secondary-600 text-xs rounded-full">
                      {item.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}